import * as React from "react";
import {useState, useEffect} from "react";
import { Pagination, NumberInput, List, FormTab, TabbedForm, Datagrid, useRecordContext, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useDataProvider, Create, required, DateTimeInput } from 'react-admin';
import { AddressList } from "../components/adressList";
import { OrderList } from "../components/orderList";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {default as commonStyles} from "./../styles/common.js";
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import { fetcherSync } from "../utils/fetcher";
import config from "../config";
import { timestampToStrDate, downloadFile } from "../utils/utils";
import MUITextField from '@mui/material/TextField';
import MUIButton from '@mui/material/Button';

const ClientLastOrder = (props) => {
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const [lastOrder, setLastOrder] = useState();
    
    useEffect(() => {

        if(record != undefined){
            var id = record.clientId;
            if(record.hasOwnProperty("clientId"))
                id = record.clientId;
            
            var res = fetcherSync(config.API_HOST+'/users/'+id+"/orders", "GET");
            if(res.length > 0){
                setLastOrder(res[res.length-1]);
            }
        }
            
    }, [record]);

    if (!record) return null;
    if(!lastOrder) return <span>Aucune commande</span>;
    else return <span>{timestampToStrDate(lastOrder.creationDate)}</span>
};

const EmailForm = (props) => {
    const record = useRecordContext();
    const [mailSubject, setMailSubject] = useState("");
    const [mailSubtitle, setMailSubtitle] = useState("");
    const [mailContent, setMailContent] = useState("");
    const [mailSending, setMailSending] = useState(false);

    const sendMail = () => {
        if(mailContent.length == 0 || mailSubtitle.length == 0 || mailSubject.length == 0){
            alert("Veuillez remplir les champs.");
            return;
        }

        setMailSending(true);

        let result = fetcherSync(config.API_HOST+"/utils/sendMail", "POST", {
            name: record.name,
            content: mailContent,
            subtitle: mailSubtitle,
            subject: mailSubject,
            email: record.extends.email
        });


        alert("Email envoyé")
        setMailSubject("");
        setMailSubtitle("");
        setMailContent("");
        setMailSending(false);
    }


    if (!record) return null;
    return (
        <Stack spacing={2}
            style={{
                width: "50%",
                margin: "auto"
            }}>
            <MUITextField
                id="email-subject"
                label="Objet de l'email"
                onChange={(e) => setMailSubject(e.target.value)}
                value={mailSubject}
            />
            <MUITextField
                id="email-subtitle"
                label="Sous-titre de l'email"
                onChange={(e) => setMailSubtitle(e.target.value)}
                value={mailSubtitle}
            />
            <MUITextField
                id="email-content"
                label="Contenu de l'email"
                onChange={(e) => setMailContent(e.target.value)}
                value={mailContent}
                multiline
                
            />
            <MUIButton disabled={mailSending} color="success" onClick={() => sendMail()}>Envoyer l'email</MUIButton>
        </Stack>
    );
}

const SMSForm = (props) => {
    const record = useRecordContext();
    const [smsContent, setSmsContent] = useState("");
    const [smsSending, setSmsSending] = useState(false);

    const sendSms = () => {
        if(smsContent.length == 0){
            alert("Veuillez remplir les champs.");
            return;
        }

        setSmsSending(true);

        let result = fetcherSync(config.API_HOST+"/utils/sendSMS", "POST", {
            content: smsContent,
            phone: record.extends.phone
        });

        alert("SMS envoyé")
        setSmsContent("");
        setSmsSending(false);
    }


    if (!record) return null;
    return (
        <Stack spacing={2}
            style={{
                width: "50%",
                margin: "auto"
            }}>
            <MUITextField
                id="sms-content"
                label="Contenu du SMS"
                onChange={(e) => setSmsContent(e.target.value)}
                value={smsContent}
                multiline
            />
            <MUIButton disabled={smsSending} color="success" onClick={() => sendSms()}>Envoyer le SMS</MUIButton>
        </Stack>
    );
}

const filters = [
    <TextInput label="ID" source="id" alwaysOn />,
    <TextInput label="Nom" source="name" />,
    <TextInput label="Siret" source="siret" />,
];

const exportBusinesses = () => {
    downloadFile(config.API_HOST+"/exports/businesses", "businesses.csv");
}

export const BusinessList = props => (
    <List exporter={exportBusinesses} {...props} filters={filters} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des entreprises" />
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="siret" />
            <ClientLastOrder label="Dernière commande" />
            <ReferenceField source="clientId" reference="users">
                <TextField source="email" />
            </ReferenceField>
        </Datagrid>
    </List>
);

const BusinessSignupDateInput = (props) => {
    const record = useRecordContext();
    if (!record || !record.extends || !record.extends.creationDate) return null;
    return (
        <MUITextField style={props.style} margin="dense" value={timestampToStrDate(record.extends.creationDate)} disabled label={props.label} />
    );
};

export const BusinessEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition de l'entreprise" />
        <TabbedForm>
            <FormTab label="general">
                <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} source="id" label="ID utilisateur" />
                        <TextInput style={commonStyles.inputStyle} source="name" label="Nom de l'entreprise" />
                        <TextInput style={commonStyles.inputStyle} source="siret" label="Siret" />
                        <TextInput style={commonStyles.inputStyle} source="extends.email" label="Email" />
                        <NumberInput style={commonStyles.inputStyle} source="extends.newsletter" label="Accepte les mails de communication (0: non, 1: oui)" />
                    </Stack>
                    <Stack>
                        <BusinessSignupDateInput label="Date d'inscription" source="extends.creationDate" />
                        <ReferenceInput style={commonStyles.inputStyle} source="catalogId" reference="catalogs">
                            <SelectInput optionText="name" emptyValue={1} label="Catalogue de l'entreprise" />
                        </ReferenceInput>
                        <TextInput style={commonStyles.inputStyle} source="extends.phone" label="Téléphone" />
                        <NumberInput style={commonStyles.inputStyle} source="extends.subscriptionRemainingMoney" label="Solde fidélité" />
                        <TextInput style={commonStyles.inputStyle} disabled source="extends.stripeCustomerId" label="Id stripe" />
                    </Stack>
                </Stack>
            </FormTab>
            <FormTab label="adresses">
                <AddressList source="clientId" />
            </FormTab>
            <FormTab label="commandes">
                <OrderList source="clientId" />
            </FormTab>
            <FormTab label="Envoi d'un mail">
                <EmailForm />
            </FormTab>
            <FormTab label="Envoi d'un SMS">
                <SMSForm />
            </FormTab>
        </TabbedForm>
    </Edit>
);

export const BusinessCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'une entreprise" />
        <TabbedForm>
            <FormTab label="general">
                <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} source="name" validate={required()} label="Nom de l'entreprise" />
                        <TextInput style={commonStyles.inputStyle} source="siret" validate={required()} label="Siret" />
                        <TextInput style={commonStyles.inputStyle} source="phone" validate={required()} label="Téléphone" />
                    </Stack>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} source="email" validate={required()} label="Email" />
                        <TextInput style={commonStyles.inputStyle} source="password" validate={required()} label="Mot de passe" />
                        <NumberInput style={commonStyles.inputStyle} source="extends.subscriptionRemainingMoney" validate={required()} label="Solde fidélité" />
                    </Stack>
                </Stack>
            </FormTab>
            <FormTab label="adresse">
                <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} source="address1" validate={required()} label="Adresse" />
                        <TextInput style={commonStyles.inputStyle} source="address2" validate={required()} label="Complément d'adresse n°1" />
                        <TextInput style={commonStyles.inputStyle} source="address3" validate={required()} label="Complément d'adresse n°2" />
                    </Stack>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} source="city" validate={required()} label="Ville" />
                        <TextInput style={commonStyles.inputStyle} source="postalCode" validate={required()} label="Code postal" />
                        <TextInput style={commonStyles.inputStyle} source="wording" validate={required()} label="Description" />
                    </Stack>
                </Stack>
            </FormTab>
        </TabbedForm>
    </Create>
);
